import React from 'react'
interface RenderOptionIconProps {
  icon: React.ReactElement
  size: number
}

const RenderOptionIcon: React.FC<RenderOptionIconProps> = ({ icon }) => {
  return <>{icon}</>
}

export default RenderOptionIcon
